import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApplicationResponse } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";
import { HolidayStore } from "../domain/holiday-model";

export const createHoliday = createAsyncThunk<void, any>(
  "holiday/create",
  async (payload: any) => {
    const url = `${AppConstants.api}/holiday`;
    const response = await api.post<ApplicationResponse<any>>(url, payload);
    return response.data.data || [];
  }
);
export const createHolidayRange = createAsyncThunk<void, {startDate: string,endDate:string,name:string,workingDay?:boolean,reason?:string}>(
  "holiday/createHolidayRange",
  async ({startDate,endDate,name,workingDay,reason}) => {
    const url = `${AppConstants.api}/holiday/create?start_date=${startDate}&end_date=${endDate}&name=${name}&working_day=${workingDay}&reason=${reason}`;
    const response = await api.post<ApplicationResponse<any>>(url);
    return response.data.data || [];
  }
);

export const updateHoliday = createAsyncThunk<void, any>(
  "holiday/update",
  async (payload: any) => {
    const url = `${AppConstants.api}/holiday`;
    const response = await api.put<ApplicationResponse<any>>(url, payload);
    return response.data.data || [];
  }
);

export const deleteHoliday = createAsyncThunk(
  "holiday/delete",
  async (id: string) => {
    try {
      const response = await api.delete<ApplicationResponse<any[]>>(
        `${AppConstants.api}/holiday?id=${id}`
      );
      return response.data.data || [];
    } catch (err) {
      return [];
    }
  }
);

export const fetchHolidayList = createAsyncThunk<any[], void>(
  "holiday/fetch",
  async () => {
    const response = await api.get<ApplicationResponse<any[]>>(
      `${AppConstants.api}/holiday`
    );
    return response.data.data || [];
  }
);

const holidaySlice = createSlice({
  name: "holiday",
  initialState: {
    minimal: { status: "loading", error: null, data: [] },
  } as HolidayStore,
  reducers: {
    resetState: (state) => {
      state.minimal = { status: "loading", error: null, data: [] };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHolidayList.pending, (state, action) => {
        state.minimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchHolidayList.fulfilled, (state, action) => {
        state.minimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchHolidayList.rejected, (state, action) => {
        state.minimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      });
  },
});

export const { resetState } = holidaySlice.actions;
export default holidaySlice.reducer;
